// v2.21.1 (audit S-1/S-3): Nginx answers 413 (too large) and 429 (too many login attempts) with its own
// HTML page, without the server's "detail" — give the person a clear message instead of a generic one.
export function detailBatas(status, data) {
  if (data && typeof data === "object" && data.detail != null) return null;  // the server's own message wins
  if (status === 429) return "Terlalu banyak percobaan. Tunggu beberapa menit lalu coba lagi.";
  if (status === 413) return "Kiriman terlalu besar. File maksimal 16 MB.";
  return null;
}
